<div class="modal-body" *ngIf="isDataLoaded">
  <span
    class="material-icons pr-2 card-close d-flex cursor-pointer cursor-pointer"
    (click)="closeCardPreview()"
  >
    cancel
  </span>
  <div class="personalize-card position-relative">
    <div class="p-box preview-card-box container-fluid position-relative">
      <div class="card-c">
        <div class="i-card-container">
          <div class="card-holder">
            <img
              [src]="envelopeImagePath"
              class="envelope"
              *ngIf="envelopeImagePath?.length > 0"
              alt="Envelope
                        Image"
            />
            <img
              [src]="previewImagePath"
              class="card-image"
              *ngIf="previewImagePath?.length > 0"
              alt="Preview Image"
            />
          </div>
        </div>
        <div class="c-area">
          <div class="card-head mt-0 text-left font-700 i-header">
            {{ currentCard?.NameEnglish }}
          </div>
          <p>Birthday Invitation</p>
          <div class="d-flex justify-content-between">
            <div class="cost">
              <div class="price" *ngIf="sharedService.userCountry == 'US'">
                <span>${{ currentCard?.FinalPrice }}</span>
                <span
                  *ngIf="currentCard?.FinalPrice != currentCard?.Price"
                  class="text-muted ml-1"
                  ><small
                    ><del> ${{ currentCard?.Price }}</del></small
                  ></span
                >
              </div>
              <div class="price" *ngIf="sharedService.userCountry == 'AE'">
                <span>AED {{ currentCard?.FinalPriceAED }} </span>
                <span
                  *ngIf="currentCard?.FinalPriceAED != currentCard?.PriceAED"
                  class="text-muted ml-1"
                  ><small
                    ><del> AED {{ currentCard?.PriceAED }}</del></small
                  ></span
                >
              </div>
              <div class="price" *ngIf="sharedService.userCountry == 'IN'">
                <span>₹{{ currentCard?.FinalPriceINR }}</span>
                <span
                  *ngIf="currentCard?.FinalPriceINR != currentCard?.PriceINR"
                  class="text-muted ml-1"
                  ><small
                    ><del> ₹{{ currentCard?.PriceINR }}</del></small
                  ></span
                >
              </div>
            </div>
            <div id="price-badge" class="d-lg-flex align-items-center">
              <div class="gi-badge-premium">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.1397 6.50199L16.8722 9.5533C16.3067 9.95872 15.4959 9.71333 15.2505 9.06253L13.2341 3.6854C12.8927 2.75721 11.5804 2.75721 11.239 3.6854L9.21191 9.05186C8.96653 9.71333 8.16636 9.95872 7.60091 9.54263L3.33335 6.49132C2.47984 5.89387 1.34893 6.73671 1.70101 7.72892L6.13927 20.1582C6.28863 20.5849 6.69405 20.8623 7.14215 20.8623H17.3096C17.7577 20.8623 18.1631 20.5743 18.3125 20.1582L22.7507 7.72892C23.1135 6.73671 21.9826 5.89387 21.1397 6.50199Z"
                    fill="#ed256b"
                  ></path>
                </svg>
                <span> Premium </span>
              </div>
            </div>
          </div>
          <div class="form-row mt-3 align-items-center justify-content-center">
            <div class="col-md-12 col-12">
              <div class="video-post-card h-auto btn-view-more border-0">
                <a (click)="closeCardPreview()"
                  [routerLink]="
                    '/personalise/' +
                      currentCard?.NameEnglish +
                      '-card-Invitations/card'
                      | formateUrl : 'cardId=' + currentCard?.CardId
                  "
                  class="btn-gray-outline btn-large btn-primary-outline w-100 d-block" target="_blank"
                  >Customize Now</a
                >
              </div>
            </div>
          </div>
          <div class="p-4 mb-2 spread-joy">
            <div class="sj-tital mb-3">Spread the joy</div>
            <ul class="text-small-medium py-2">
              <li class="mb-3 d-flex align-items-center">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.2133 7.57677V2.5M16.2197 5.56315L14.2134 7.57845L12.2062 5.56315M2.50326 12.9836L5.79423 10.5944C7.01315 9.70883 8.67892 9.78992 9.80783 10.7817L16.2195 16.5341M17.4987 12.9017C16.7996 12.2594 15.7112 11.2359 14.232 12.0323C13.468 12.4459 12.7941 12.8774 12.4202 13.1288M17.5 9.1315V13.317C17.5 15.771 15.964 17.5017 13.5099 17.5017H6.48194C4.0279 17.5017 2.5 15.771 2.5 13.317V6.69445C2.5 4.24041 4.03601 2.50977 6.48194 2.50977H9.44775"
                    stroke="#20282D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span id="design-download-image" class="ms-2">
                  Download image
                </span>
              </li>
              <li class="mb-3 d-flex">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.526 10.793V7.63395C16.526 7.18073 16.3506 6.74514 16.0375 6.41866L12.7928 3.03885C12.4622 2.69474 12.0047 2.50002 11.5272 2.50002H6.69121C4.9455 2.49331 3.51451 3.88401 3.47339 5.62972V10.793M11.9402 2.55208V5.02714C11.9393 6.23572 12.9171 7.21601 14.1257 7.21852H16.4698M3.6801 16.2265H4.84419C5.55591 16.2265 6.13333 15.6491 6.13333 14.9374C6.13333 14.2265 5.55591 13.6491 4.84419 13.6491H3.6801V17.4947M16.5251 13.6458H14.4369V17.5007M16.2041 15.8948H14.4373M9.71191 17.5007C10.2231 17.5007 10.7132 17.2976 11.075 16.9358C11.4367 16.5749 11.6398 16.0848 11.6398 15.5737C11.6398 15.0618 11.4367 14.5716 11.075 14.2107C10.7132 13.8489 10.2231 13.6458 9.71191 13.6458H8.74841V17.5007H9.71191Z"
                    stroke="#20282D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>

                <span id="design-download-pdf" class="ms-2">
                  Download PDF
                </span>
              </li>
              <!-- <li class="d-flex">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.17541 14.6922H5.27541C3.74541 14.6922 2.5 13.4549 2.5 11.9249V8.5795C2.5 7.05677 3.74541 5.81218 5.27541 5.81218H14.7327C16.2627 5.81218 17.5 7.05677 17.5 8.5795V11.9249C17.5 13.4549 16.2627 14.6922 14.7327 14.6922H13.8554M6.17758 12.3405V15.4824C6.17758 16.4399 6.95352 17.2159 7.91108 17.2159H12.09C13.0468 17.2159 13.8227 16.4399 13.8227 15.4824V12.3405M14.5538 12.3405H5.44759M14.7176 8.79234H12.9508M6.17838 5.82374V4.51672C6.17838 3.55996 6.95433 2.7832 7.9119 2.7832H12.0908C13.0476 2.7832 13.8235 3.55996 13.8235 4.51672V5.82374"
                    stroke="#20282D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span id="design-print" class="ms-2"> Print </span>
              </li>
              <li class="d-flex mt-3">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.44212 11.1318L12.5648 14.1172M12.5567 5.88216L7.44132 8.86675M14.4998 2.5C15.7428 2.5 16.7498 3.50702 16.7498 4.74997C16.7498 5.99293 15.7428 6.99995 14.4998 6.99995C13.2569 6.99995 12.2499 5.99293 12.2499 4.74997C12.2499 3.50702 13.2569 2.5 14.4998 2.5ZM5.50022 7.74963C6.74318 7.74963 7.75019 8.75668 7.75019 9.99959C7.75019 11.2426 6.74318 12.2496 5.50022 12.2496C4.25726 12.2496 3.25024 11.2426 3.25024 9.99959C3.25024 8.75668 4.25726 7.74963 5.50022 7.74963ZM14.4998 13.0001C15.7428 13.0001 16.7498 14.0071 16.7498 15.25C16.7498 16.4922 15.7428 17.5 14.4998 17.5C13.2569 17.5 12.2499 16.4922 12.2499 15.25C12.2499 14.0071 13.2569 13.0001 14.4998 13.0001Z"
                    stroke="#20282D"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
                <span id="design-share" class="ms-2"> Share </span>
              </li> -->
            </ul>
          </div>

          <!-- <div class="text-orange mt-3 cursor-pointer d-flex align-items-center justify-content-md-start justify-content-center" (click)="openPreviewExperience()">
                        <span class="material-icons text-orange">
                            play_arrow
                            </span> <span>
                                Preview experience
                            </span>
                    </div> -->
          <div class="form-row mt-2 align-items-center d-none d-md-flex mt-4">
            <div class="col-auto">
              <span class="material-icons"> palette </span>
            </div>
            <div class="col card-text">
              Change your card’s text, style, envelope, backdrop and more
            </div>
          </div>
          <div class="form-row mt-2 align-items-center d-none d-md-flex">
            <div class="col-auto">
              <span class="material-icons"> schedule_send </span>
            </div>
            <div class="col card-text">
              Add your event’s details, make or import a guest list, and send
              with a click
            </div>
          </div>
          <div class="form-row mt-2 align-items-center d-none d-md-flex">
            <div class="col-auto">
              <span class="material-icons"> format_list_bulleted </span>
            </div>
            <div class="col card-text">
              Track RSVPs and communicate with guests instantly
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <section class="section-divider-1 section-tabs px-lg-1 row-spacer-30">
    <div class="container-fluid">
      <div class="site-section-header mt-4">
        <div class="row justify-content-start">
          <div class="col-md-auto">
            <h2>You might also like</h2>
          </div>
        </div>
      </div>
      <div class="cards-row">
        <div
          class="mobile-card-container desk-no-scroll"
          *ngIf="similiarCardData != null && similiarCardData.length === 4 > 0"
        >
          <div class="scrolling-wrapper">
            <app-card-post
              [card]="item"
              *ngFor="let item of similiarCardData"
            ></app-card-post>
          </div>
        </div>
      </div>
    </div>
  </section> -->
</div>
